//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../Motion/Motion.SignalChartListItemList.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ObjectList.js";
let d=[[[1,"ClosedSignalList",0,"Motion.SignalChartListItemList",0],[1,"InitialSignalExpression",0,"Expression",0],[0,"Name",1,0],[0,"OpenSignalFunction",1,"CAE.Function",0],[0,"SignalChartType",1,0]],[[["sensor","alwaysEvaluated","time_sensor","condition","threshold","delayTime","signal"],"NewListItemExpression",{R_:{listitem:"Motion.SignalChartListItem"}},7,0]],[]];
SPLM.Motion.SignalChartBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.SignalChartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.SignalChartBuilder.Type = Object.freeze({
    "OpenLoop" : "OpenLoop", "ClosedLoop" : "ClosedLoop"});

export default SPLM;